import {IPresentation} from '../presentation';
import {User} from '../user';
import {RoomStatus} from './room.player';
import {ProtectionInfo} from '../presentationProtection';

export enum LeaderboardVisibility {
    TOP_N = 'topN',
    ALL = 'all',
}

export const DEFAULT_LEADERBOARD_VISIBILITY = LeaderboardVisibility.TOP_N;
export const DEFAULT_LEADERBOARD_SIZE = 10;
export const DEFAULT_LEADERBOARD_SHOW_PERSONAL_RANK = true;

export interface IFetchRoom {
    _id: string;
    roomName: string;
    roomStatus: RoomStatus;
    presentation: IPresentation;
    protection: ProtectionInfo;
    lastModified: number;
    identification?: IRunfileIdentification;
    presenter: User;
    presentationId: string;
    presenterId: string;
    presenterEmail: string;
    presenterHash?: {hash: string; exp: Date};
    presenterLinkCode?: string;
    leaderboardVisibility?: LeaderboardVisibility;
    leaderboardSize?: number;
    leaderboardShowPersonalRank?: boolean;
    startTime?: string;
    endTime?: string;
}

export interface IFetchRoomPaginated {
    _id: string;
    roomName: string;
    presentation: IPresentation;
    protection: ProtectionInfo;
    lastModified: number;
    presenterLinkCode?: string;
    leaderboardVisibility?: LeaderboardVisibility;
    leaderboardSize?: number;
    leaderboardShowPersonalRank?: boolean;
}

export interface ICreateRoom {
    roomName: string;
    presentationId: string;
    protection: ProtectionInfo;
    presenterId?: string | null;
    presenterEmail?: string;
    startTime?: string | null;
    endTime?: string | null;
}

export interface ICreatedRoom {
    _id: string;
    presenterLinkCode?: string;
}

export interface IUpdateRoom {
    _id: string;
    roomName: string;
    presentationId: string;
    protection: ProtectionInfo;
    presenterId?: string | null;
    presenterEmail?: string;
    identification?: IRunfileIdentification;
    roomStatus?: RoomStatus;
    presenterHash?: {hash: string; exp: number} | null;
    roomRunFileId?: string;
    leaderboardVisibility?: LeaderboardVisibility;
    leaderboardSize?: number;
    leaderboardShowPersonalRank?: boolean;
    startTime?: string | null;
    endTime?: string | null;
}

export interface IRunfileIdentification {
    specificIdentificationOn?: boolean;
    specificIdentificationLabel?: string;
    groupIdentificationOn?: boolean;
    groupIdentificationLabel?: string;
    options?: string[];
}

export enum UsersInRoomSearchView {
    ALL = 'all',
    CONNECTIONS = 'connections',
}
